module.exports = __webpack_public_path__ + "static/media/sAVAX.f6f043d1.png";